import { render, staticRenderFns } from "./NewActivity.vue?vue&type=template&id=bd59cb6c"
import script from "./NewActivity.vue?vue&type=script&lang=js"
export * from "./NewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports